import {useDispatch, useSelector} from 'react-redux'
import {useTranslation} from 'next-i18next'
import {makeStyles} from '@material-ui/core/styles'
import {
  getSelectedGuests,
  getSelectedLocation,
} from 'src/store/selectors/propertySearchSelectors'
import {
  setSelectedGuests,
  setSortByFilter,
} from 'src/store/actions/propertySearchActions'
import {GuestSelectType} from 'src/types/guestSelect'
import {BaseStepProps} from 'src/components/modules/home/homeHero/mobileSearch/MobileSearch'
import GuestSelect from 'src/components/elements/GuestSelect'
import AppButton from 'src/components/elements/buttons/AppButton'
import {globalZIndex} from 'src/utils/styles'

//todo convert to styles.module.css or tailwind utility classes
const useStyles = makeStyles(
  ({palette, spacing}) => ({
    container: {
      position: 'relative',
    },
    footer: {
      position: 'fixed',
      display: 'flex',
      width: '100%',
      bottom: 0,
      padding: spacing(0, 20 / 8, 20 / 8, 20 / 8),
      left: 0,
      background: palette.common.white,
      zIndex: globalZIndex.moreAboveBase,
    },
  }),
  {index: 2},
)

export default function Guests({changeStep}: BaseStepProps) {
  const {t} = useTranslation('common')
  const classes = useStyles()
  const dispatch = useDispatch()
  const selectedLocation = useSelector(getSelectedLocation)
  const guests = useSelector(getSelectedGuests)

  const handleChangeGuest = (guests: GuestSelectType) => {
    dispatch(setSelectedGuests(guests))

    if (!selectedLocation.address) {
      dispatch(setSortByFilter('relevance'))
    }
  }

  const handleDoneClick = () => changeStep('filters')

  return (
    <div className={classes.container}>
      <GuestSelect guests={guests} onChangeGuest={handleChangeGuest} />
      <div className={classes.footer}>
        <AppButton
          children={t('done')}
          variant={'contained'}
          color={'primary'}
          onClick={handleDoneClick}
          style={{
            width: '100%',
            height: 40,
            borderRadius: 24,
            marginLeft: 8,
            marginRight: 8,
            marginTop: 10,
          }}
        />
      </div>
    </div>
  )
}
